<div id='f_content'>
    <ng-content></ng-content>
</div>
<div di='f_loader' *ngIf="fetchingChunk">
    <app-loader-round [isInline]="true" [isVisible]="true" [height]="50" [backgroundColor]="loaderBackground"></app-loader-round>
</div>